import { initialize } from '@open-iframe-resizer/core';

// Run the functions on document ready
document.addEventListener('DOMContentLoaded', () => {
    initialize({ enableLegacyLibSupport: true }, 'iframe[data-dynamic-height]');
});
